import React, { Component } from "react";

const LANGUAGES = [
	{ code: "en", flag: "🇨🇦", label: "EN" },
	{ code: "fr", flag: "🇫🇷", label: "FR" },
	{ code: "es", flag: "🇪🇸", label: "ES" },
	{ code: "pt", flag: "🇧🇷", label: "PT" },
	{ code: "de", flag: "🇩🇪", label: "DE" },
	{ code: "it", flag: "🇮🇹", label: "IT" },
];

class LanguagePicker extends Component {
	constructor(props) {
		super(props);
		this.state = {
			currentLang: this.getCurrentLang(),
			isOpen: false,
		};
		this.toggleDropdown = this.toggleDropdown.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.containerRef = React.createRef();
	}

	componentDidMount() {
		document.addEventListener("mousedown", this.handleClickOutside);
	}

	componentWillUnmount() {
		document.removeEventListener("mousedown", this.handleClickOutside);
	}

	handleClickOutside(e) {
		if (this.containerRef.current && !this.containerRef.current.contains(e.target)) {
			this.setState({ isOpen: false });
		}
	}

	getCurrentLang() {
		const cookies = document.cookie.split(";");
		for (let cookie of cookies) {
			const trimmed = cookie.trim();
			if (trimmed.startsWith("googtrans=")) {
				const parts = trimmed.split("=")[1].split("/");
				if (parts[2]) return parts[2];
			}
		}
		return "en";
	}

	triggerTranslate(lang) {
		const expired = "expires=Thu, 01 Jan 1970 00:00:00 GMT";
		const host = window.location.hostname;
		document.cookie = `googtrans=; path=/; ${expired}`;
		document.cookie = `googtrans=; path=/; domain=${host}; ${expired}`;
		document.cookie = `googtrans=; path=/; domain=.${host}; ${expired}`;
		document.cookie = `googtrans=/en/${lang}; path=/`;
		document.cookie = `googtrans=/en/${lang}; path=/; domain=${host}`;
		window.location.reload();
	}

	toggleDropdown() {
		this.setState(prev => ({ isOpen: !prev.isOpen }));
	}

	render() {
		const { currentLang, isOpen } = this.state;
		const current = LANGUAGES.find(l => l.code === currentLang) || LANGUAGES[0];

		return (
			<div className="lang-picker notranslate" translate="no" ref={this.containerRef}>
				<button className="lang-picker-btn" onClick={this.toggleDropdown}>
					<span className="lang-picker-flag">{current.flag}</span>
					<span className="lang-picker-code">{current.label}</span>
					<svg className="lang-picker-arrow" viewBox="0 0 20 20" width="12" height="12" fill="currentColor">
						<path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
					</svg>
				</button>
				{isOpen && (
					<div className="lang-picker-dropdown">
						{LANGUAGES.map(lang => (
							<div
								key={lang.code}
								className={`lang-picker-option${lang.code === currentLang ? " active" : ""}`}
								onClick={() => this.triggerTranslate(lang.code)}
							>
								<span className="lang-picker-flag">{lang.flag}</span>
								<span className="lang-picker-code">{lang.label}</span>
							</div>
						))}
					</div>
				)}
			</div>
		);
	}
}

export default LanguagePicker;
